import React from 'react';
import {Theme, ThemeName, LoadingLosenge} from '@taopix/taopix-design-system';

type LoadOrFailPanelTypes = {
  status: 'loading' | 'failed';
  failureMessage?: string;
};

const LoadOrFailPanel = ({status, failureMessage}: LoadOrFailPanelTypes) => {
  return (
    <Theme
      name={ThemeName.Container}
      className={'flex-1 basis-[300px] flex justify-center items-center px-lg'}
      allowCorners={false}
      allowBorder={false}
    >
      {status === 'loading' ? (
        <LoadingLosenge />
      ) : (
        <p className={'text-center'}>{failureMessage}</p>
      )}
    </Theme>
  );
};

export default LoadOrFailPanel;
